
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Geht die Sonne abends unter, erscheint das Licht gelblich bis rötlich. Das liegt daran, dass der Blauteil, der unserem Gehirn «Tag» signalisiert, sinkt. Die Folge: Wir werden müde. Doch was, wenn wir vor dem Einschlafen ständig auf das blaue Display-Licht unseres Tablets, Laptops oder Smartphones blicken? Ob uns dieses wirklich vom Schlafen abhält, kann durch die bisherige Forschung nicht klar ausgeschlossen oder bestätigt werden. `}<M mdxType="M">{`Klar ist, dass spezielle Rezeptoren in unserer Netzhaut besonders empfindlich auf blaue Wellenlängen reagieren.`}</M>{` Sie leiten die Wahrnehmung von Licht an unser Gehirn weiter, wodurch die Sekretion des Schlafhormons Melatonin gehemmt wird. In einzelnen `}<Link href='https://www.medizin-transparent.at/schlaflos-durch-blaues-licht#ref2' mdxType="Link">{`Studien`}</Link>{` konnte gezeigt werden, dass Menschen, die abends auf einen LED-Screen blickten, weniger Melatonin im Speichel hatten als diejenigen, die ein Buch lasen – oder eine Blaufilterbrille trugen. Wie stark der Effekt des Lichts tatsächlich ist, bleibt aber unklar. Auch der Inhalt der Texte, Videos und Nachrichten, die wir uns im Bett via Bildschirm zu Gemüte führen, kann indes dazu führen, dass wir unruhiger einschlafen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;